import { useImageFilesQueries } from "shared/queries/useImageFileQueries";
import { GameDetailsType } from "../context/types";

type useUploadGameImagesProps = Pick<
  GameDetailsType,
  "setBackgroundFile" | "setLogoFile" | "gameDetails"
>;

export const useUploadGameImages = ({
  gameDetails,
  setBackgroundFile,
  setLogoFile,
}: useUploadGameImagesProps) => {
  const queries = [
    {
      queryKey: ["game-bg-image-file", (gameDetails?.id ?? "").toString()],
      path: gameDetails?.bgImage,
      setImageFile: setBackgroundFile,
    },

    {
      queryKey: ["game-lg-image-file", (gameDetails?.id ?? "").toString()],
      path: gameDetails?.logoImage,
      setImageFile: setLogoFile,
    },
  ];

  const imageQueries = useImageFilesQueries({ queries, enabled: Boolean(gameDetails?.id) });

  return {
    isBgImageLoaded: imageQueries[0].isLoading || imageQueries[0].isRefetching,
    isLogoImageLoaded: imageQueries[1].isLoading || imageQueries[1].isRefetching
  };
};
